import { render } from "./TestDesktopView.vue?vue&type=template&id=bd0d11da&scoped=true"
import script from "./TestDesktopView.vue?vue&type=script&lang=js"
export * from "./TestDesktopView.vue?vue&type=script&lang=js"

import "./TestDesktopView.vue?vue&type=style&index=0&id=bd0d11da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0d11da"]])

export default __exports__